import { FullStoryAPI, event as fsEvent } from 'react-fullstory';
import { event as gaEvent, set as gaSetProperties, initialize, pageview } from 'react-ga';
import { Userpilot } from 'userpilot';
import AppSettings from '../app-settings';

interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt?: Date;
  userType: 'Buyer' | 'Seller';
  site?: {
    _id: string;
    siteName: string;
  };
  buyerSite?: {
    _id: string;
    siteName: string;
  };
}

interface EventProps {
  [property: string]: string;
}

class Tracking {
  static Initialize(): void {
    Userpilot.initialize(AppSettings.USERPILOT_APP_TOKEN);
    initialize(AppSettings.GOOGLE_ANALYTICS_ID);
  }

  static Identify(user: User): void {
    let userSite = user.site ? user.site : { _id: 'none', siteName: 'none' };
    if (user.buyerSite) userSite = user.buyerSite;
    const shouldIdentify = localStorage.getItem('shouldIdentify') === 'yes';
    if (shouldIdentify) {
      FullStoryAPI('identify', user._id, {
        email: user.email,
      });
      localStorage.removeItem('shouldIdentify');
    }
    Userpilot.identify(user._id, {
      name: user.firstName,
      first_name: user.firstName,
      last_name: user.lastName,
      created_at: user.createdAt,
      email: user.email,
      user_type: user.userType,
      company: {
        id: userSite._id,
        name: userSite.siteName,
      },
    });
    gaSetProperties({ userId: user._id, userEmail: user.email, userSite: userSite._id });
  }

  static PageChange(location: Location): void {
    window.setTimeout(() => {
      Userpilot.reload(location.href);
      pageview(`${location.pathname}${location.search}${location.hash}`);
    }, 100);
  }

  static Event(eventName: string, props?: EventProps): void {
    fsEvent(eventName, props);
    Userpilot.track(eventName, props);
    gaEvent({
      category: 'UserAction',
      action: eventName,
      ...props,
    });
  }
}

export default Tracking;
